import { render } from "./area-chart.component.vue?vue&type=template&id=6b82d077&scoped=true"
import script from "./area-chart.component.vue?vue&type=script&lang=js"
export * from "./area-chart.component.vue?vue&type=script&lang=js"

import "./area-chart.component.vue?vue&type=style&index=0&id=6b82d077&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b82d077"

export default script